import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, map, Observable, of } from 'rxjs';
import { GetOrdersByConfirmResponse } from '../../home/interfaces/get-orders-by-confirm.response';
import { OrdersConfirmByUserRequest } from '../../home/interfaces/orders-confirm-by-user.request';
import { ModalService } from './modal.service';

const API_URL = environment.apiUrl;

@Injectable({ providedIn: 'root' })
export class OrderReferenceService {
  private http = inject(HttpClient);
  private modalService = inject(ModalService);

  getOrdersByConfirm(): Observable<GetOrdersByConfirmResponse[]> {
    return this.http.get<GetOrdersByConfirmResponse[]>(
      `${API_URL}/ordersByConfirm`
    );
  }

  ordersConfirmByUser(request: OrdersConfirmByUserRequest) {
    return this.http.post(`${API_URL}/OrdersConfirmByUser`, request).pipe(
      map(() => true),
      catchError((err: HttpErrorResponse) => {
        this.modalService.showErrorModal(err);
        return of(false);
      })
    );
  }
}
